<template>
  <div class="animated fadeIn">
    <b-row class="mb-0">
      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range.startDate"
            :max="range.endDate == '' ? maxDate : range.endDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range.endDate"
            :min="range.startDate"
            :max="maxDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Comercial</label>
          <b-form-select v-model="staff_id" :disabled="role_id != 1 && role_id != 7" @change="getAllInfo()">
            <template slot="first">
              <option :value="null">-- Comercial--</option>
            </template>
            <option
              v-for="item in lstStaffs"
              :key="item.id"
              :value="item.id"
            >{{ item.name }} {{ item.last_name }} ({{ item.type_name }})</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label class="mb-0">Departamento</label>
          <b-form-select id="cmbDepartamento" v-model="zone_id" @change="getCitiesByZoneAddress()">
            <template slot="first">
              <option :value="null">-- Departamento --</option>
            </template>

            <option v-for="item in lstDepartamento" :key="item.id" :value="item.id">{{ item.name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Ciudad</label>
          <b-form-select class="mb-3" id="cmbCiudad" v-model="city_id" @change="getAllInfo()">
            <template slot="first">
              <option :value="null">-- Ciudad --</option>
            </template>

            <option v-for="item in lstCiudad" :key="item.id" :value="item.id">{{ item.name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div id="print_div">
      <b-row>
        <b-col sm="6" lg="3">
          <b-card no-body class="bg-primary">
            <b-card-body class="pb-0 text-center" style="height:150px;">
              <p class="text-uppercase font-weight-bold">Cuentas</p>
              <p class="mb-2 card-box-number">{{totalCustomers}}</p>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="bg-info">
            <b-card-body class="pb-0 text-center" style="height:150px;">
              <p class="text-uppercase font-weight-bold">Cartera</p>
              <p class="mb-2 card-box-number">${{formatPrice(totalMoney)}}</p>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="bg-warning">
            <b-card-body class="pb-0 text-center" style="height:150px;">
              <p class="text-uppercase font-weight-bold">Comisión</p>
              <p class="mb-2 card-box-number">$3.000.000</p>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="bg-danger">
            <b-card-body class="pb-0 text-center" style="height:150px;">
              <p class="text-uppercase font-weight-bold">Meta</p>
              <p class="mb-2 card-box-number">10%</p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <!-- INICIO GRAFICAS -->
      <b-row>
        <b-col sm="6">
          <b-card header="CARTERA">
            <div class="chart-wrapper">
              <b-row
                class="justify-content-center align-items-center"
                v-if="dataWallet && totalDataWallet > 0"
              >
                <div class="col-md-8">
                  <pie-chart
                    chartId="chart-pie-01"
                    :data="dataWallet"
                    v-if="dataWallet && totalDataWallet > 0"
                  />
                </div>
              </b-row>

              <div v-else class="without" style="margin-top:0px">
                <div class="row">
                  <figure class="text-center figure-dash">
                    <img src="img/sin_gestion.png" alt width="210px" />
                  </figure>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h1>Oops!</h1>
                    <h4>No hay datos</h4>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col sm="6">
          <b-card header="DINERO INGRESADO">
            <div class="chart-wrapper">
              <b-row
                v-if="dataMoney && totalMoney > 0"
                class="justify-content-center align-items-center"
              >
                <div class="col-md-8">
                  <pie-chart chartId="chart-pie-02" :data="dataMoney" v-if="dataMoney" />
                </div>
              </b-row>

              <div v-else class="without" style="margin-top:0px">
                <div class="row">
                  <figure class="text-center figure-dash">
                    <img src="img/sin_gestion.png" alt width="210px" />
                  </figure>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h1>Oops!</h1>
                    <h4>No hay datos</h4>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6">
          <b-card header="ÚLTIMOS SEIS MESES">
            <div class="chart-wrapper">
              <b-row
                v-if="dataMonths && totalDataMonths > 0"
                class="justify-content-center align-items-center"
              >
                <div class="col-md-8">
                  <line-chart chartId="chart-line-01" :data="dataMonths" v-if="dataMonths" />
                </div>
              </b-row>

              <div v-else class="without" style="margin-top:0px">
                <div class="row">
                  <figure class="text-center figure-dash">
                    <img src="img/sin_gestion.png" alt width="210px" />
                  </figure>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h1>Oops!</h1>
                    <h4>No hay datos</h4>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col sm="6">
          <b-card header="EMBUDO">
            <div class="chart-wrapper">
              <b-row
                v-if="dataFunnel && totalDataFunnel > 0"
                class="justify-content-center align-items-center"
              >
                <div class="col-md-8">
                  <funnel-chart :data="dataFunnel" v-if="dataFunnel" />
                </div>
              </b-row>

              <div v-else class="without" style="margin-top:0px">
                <div class="row">
                  <figure class="text-center figure-dash">
                    <img src="img/sin_gestion.png" alt width="210px" />
                  </figure>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h1>Oops!</h1>
                    <h4>No hay datos</h4>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- FIN GRAFICAS -->
    </div>
  </div>
</template>

<script>
import PieChart from "../../charts/Pie";
import LineChart from "../../charts/Line";
import FunnelChart from "../../charts/Funnel";
import { Callout } from "@coreui/vue";
import { hexToRgba } from "@coreui/coreui/dist/js/coreui-utilities";
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "dashboard",
  components: {
    PieChart,
    LineChart,
    FunnelChart,
    Callout,
    hexToRgba,
    DateRangePicker,
  },
  data: function () {
    return {
      token: localStorage.getItem("token"),
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      start_date: null,
      end_date: null,
      lstStaffs: [],
      user_id: null,
      staff_id: null,
      dataWallet: null,
      totalDataWallet: 0,
      dataMoney: null,
      dataMonths: null,
      totalDataMonths: 0,
      dataFunnel: null,
      totalDataFunnel: 0,
      wallet: null,
      totalMoney: 0,
      totalCustomers: 0,
      lstDepartamento: [],
      lstCiudad: [],
      zone_id: null,
      city_id: null,
    };
  },
  created() {
    // SE HACE TEMPORALMENTE PARA QUE RECARGUE VISTA UNA SOLA VEZ
    let readyMenu = localStorage.getItem("readyMenu");
    if (readyMenu === "N") {
      localStorage.setItem("readyMenu", "S");
      location.reload();
    }

    //LISTADO DE STAFF'S: 42: COMERCIAL
    this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
      (response) => {
        this.lstStaffs = response.data.data;
        // console.log(response.data.data);
      },
      (error) => {
        console.log(error);
      }
    );

    //DEPARTAMENTOS DE COLOMBIA
    this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
      (response) => {
        this.lstDepartamento = response.data.data;
      },
      (error) => {
        console.log(error);
      }
    );

    let auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    // console.log(auth);
    this.staff_id = this.role_id == 1 || this.role_id == 7 ? null : auth[0].staff_id;
    this.user_id = auth[0].id;

    this.getAllInfo();
  },
  methods: {
    changeDate() {
      if (this.range.startDate != "" && this.range.endDate != "") {
        this.getAllInfo();
      } else return;
    },
    getAllInfo() {
      showLoader();
      this.start_date = moment(this.range.startDate).format("YYYY-MM-DD");
      this.end_date = moment(this.range.endDate).format("YYYY-MM-DD");
      this.getMainInformation();
      this.getWallet();
      this.getComercialmoneyEntered();
      this.getLastSixMonths();
      this.getComercialCountAdvance();
      hideLoader();
    },
    getMainInformation() {
      this.$http
        .get(
          `${this.$urlApi}customers/count/staff/${this.staff_id}/${this.start_date}/${this.end_date}/${this.city_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log('totalCustomers ------------------------->',response);
            this.totalCustomers = response.data.data.total_customers;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getWallet() {
      this.dataWallet = null;

      this.$http
        .get(
          `${this.$urlApi}debtors/wallet/staff/${this.staff_id}/${this.start_date}/${this.end_date}/${this.city_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log('getWallet ------------------------->',response);
            this.totalDataWallet = response.data.data.prejury + response.data.data.jury;

            this.dataWallet = {
              labels: ["Prejuridica", "Juridica"],
              datasets: [
                {
                  backgroundColor: ["#41B883", "#E46651"],
                  data: [response.data.data.prejury, response.data.data.jury],
                },
              ],
              mode: "percentage",
              money: true,
            };
            // console.log(this.dataWallet);
          },
          (error) => {
            console.log(error);
          }
        );
    },
    getComercialmoneyEntered() {
      this.dataMoney = null;
      this.$http.get(`${this.$urlApi}invoices/moneyentered/staff/${this.staff_id}/${this.city_id}?token=${this.token}`)
        .then((response) => {            
            this.totalMoney = response.data.data.total;
            this.dataMoney = {
              labels: ["Nuevos", "Activos"],
              datasets: [
                {
                  backgroundColor: ["#41B883", "#E46651"],
                  data: [response.data.data.news, response.data.data.actives],
                },
              ],
              mode: "percentage",
              money: true,
            };
          },
          (error) => {
            console.log(error);
          }
        );
    },

    getLastSixMonths() {
      this.dataMonths = null;

      this.$http
        .get(
          `${this.$urlApi}invoices/lastsixmonths/user/${this.user_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log(response.data);
            // console.log('getLastSixMonths ------------------------->',response);

            let labels = [];
            let preJury = [];
            let jury = [];

            for (let i = 0; i < response.data.prejury.length; i++) {
              const element = response.data.prejury[i];

              // console.log(element.mes);
              labels.push(element.mes);
              preJury.push(element.value);
              this.totalDataMonths += element.value;
            }

            for (let i = 0; i < response.data.jury.length; i++) {
              const element = response.data.jury[i];
              jury.push(element.value);
              this.totalDataMonths += element.value;
            }

            this.dataMonths = {
              labels: labels,
              datasets: [
                {
                  label: "Prejuridico",
                  backgroundColor: hexToRgba("#E46651", 90),
                  data: preJury,
                },
                {
                  label: "Jurídico",
                  backgroundColor: hexToRgba("#00D8FF", 90),
                  data: jury,
                },
              ],
            };

            // console.log(this.totalDataMonths);
          },
          (error) => {
            // console.clear()
            this.dataMonths = null;
            console.log(error);
          }
        );
    },
    getComercialCountAdvance() {
      this.dataFunnel = null;

      this.$http
        .get(
          `${this.$urlApi}customers/countadvance/staff/${this.staff_id}/${this.city_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log('getComercialCountAdvance ------------------------->',response);

            let data = response.data.data;

            let labels = [];
            let values = [];
            let total = 0;

            for (let i = 0; i < data.length; i++) {
              const element = data[i];

              total += element.value;
            }

            labels.push("Total");
            values.push(total);
            this.totalDataFunnel = total;

            for (let i = 0; i < data.length; i++) {
              const element = data[i];

              // console.log(element.mes);
              labels.push(element.name);
              values.push(element.value);
            }

            this.dataFunnel = {
              labels: labels,
              subLabels: [],
              values: values,
              colors: ["#FF4589", "#FF5050"],
              direction: "vertical",
              gradientDirection: "vertical",
              height: 325,
              width: 200,
              display_percentage: false,
            };

            // console.log(this.dataMoney);
          },
          (error) => {
            // console.clear()
            this.dataFunnel = null;
            console.log(error);
          }
        );
    },
    getCitiesByZoneAddress() {
      if (this.zone_id) {
        showLoader();
        this.$http
          .get(`${this.$urlApi}cities/${this.zone_id}?token=${this.token}`)
          .then(
            (response) => {
              this.lstCiudad = response.data.data;
              this.city_id = null;
              hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      }
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      // let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    printChart(id) {
      var canvasEle = document.getElementById(id);
      var win = window.open("", "Print", "height=600,width=800");
      win.document.write("<br><img src='" + canvasEle.toDataURL() + "' />");
      setTimeout(function () {
        //giving it 200 milliseconds time to load
        win.document.close();
        win.focus();
        win.print();
        win.location.reload();
      }, 200);
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
